module.exports = __webpack_public_path__ + "img/questionsend.1fc2760c.png";